import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';
import type {SerializedShadowOptions} from '@postermywall/fabricjs-2';

export function useGetKeyFromShadowOfActiveSlideItem<T extends keyof SerializedShadowOptions>(key: T): SerializedShadowOptions[T] | undefined | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.SLIDESHOW) {
      const itemCopy = item as SlideshowItemObject;
      const slideItem = itemCopy.slides.slidesHashMap[itemCopy.selectedSlideUID];

      if (slideItem && 'shadow' in slideItem) {
        if (!slideItem.shadow) {
          return null;
        }
        if (slideItem.shadow?.[key] !== undefined) {
          return slideItem.shadow[key];
        }
      }
    }

    return undefined;
  });
}
